// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"717":"layouts__index","835":"src__pages__school-based-course-selection"}[chunkId] + "." + {"717":"c4ec14e8","835":"a4ebdbf0"}[chunkId] + ".chunk.css";
};